import { SocialExportGetConnectionStateDto } from '@mi-front/api-v2';
import { Typography, TypographyProps } from '@mui/material';

type Props = {
  connection: Pick<SocialExportGetConnectionStateDto, 'name' | 'profile'>;
} & TypographyProps;

/**
 * Displays the connection label: custom `name` when set, otherwise profile display name.
 */
export function ConnectionDisplayName({ connection, ...typographyProps }: Props) {
  const displayName = connection.name || connection.profile.displayName;

  return <Typography {...typographyProps}>{displayName}</Typography>;
}
